/// <amd-module name="Wit/QueriesHub/Common/Components/RevertDialog" />
import * as React from "react";
import { format } from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { Dialog } from "VSSUI/Dialog";
import { QueryHierarchyItem } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import { IQueryService } from "Wit/Common/QueryService/IQueryService";
import * as Resources from "Wit/QueriesHub/Resources";

export interface IRevertDialogProps {
    onDismiss: () => void;
    onRevert?: () => void;
    pageContext: IVssPageContext;
    query?: QueryHierarchyItem;
}

export function RevertDialog(props: IRevertDialogProps) {
    return (
        <Dialog
            titleProps={{ text: Resources.ConfirmRevert }}
            onDismiss={props.onDismiss}
            footerButtonProps={[
                {
                    text: Resources.Cancel,
                    onClick: props.onDismiss
                },
                {
                    text: Resources.Continue,
                    onClick: () => RevertQuery(props),
                    primary: true
                }
            ]}
            resizable={true}
        >
            <div className="scroll-auto flex-grow flex-row">
                <div>
                    <p>{Resources.UnsavedChanges}</p>
                    <p>{format(Resources.RevertQuery, props.query ? props.query.name : Resources.UntitledQuery)}</p>
                    {
                        // Todo: render all the pending work items
                    }
                </div>
            </div>
        </Dialog>
    );
}

async function RevertQuery(props: IRevertDialogProps) {
    const queryService = props.pageContext.getService<IQueryService>("IQueryService");
    await queryService.revertQuery();
    if (props.onRevert) {
        props.onRevert();
    }
    props.onDismiss();
}
